<template>
  <div
    class="share-nav"
    @mousedown="
      (labelPopover.labelVisible = false), (labelPopover.showPopoverIndex = -1)
    "
    @mousewheel="
      (labelPopover.labelVisible = false), (labelPopover.showPopoverIndex = -1)
    "
  >
    <div
      v-if="labelPopover.labelVisible"
      class="share-popover-box"
      :style="{
        top: popover.top + 'px',
        left: popover.left + 'px',
      }"
    >
      <div class="item-popover" @mousedown.stop="handleClick('1')">
        {{ $t(`button.print`) }}
      </div>
      <div class="item-popover" @mousedown.stop="handleClick('2')">
        {{ $t(`button.editLabel`) }}
      </div>
      <div class="item-popover" @mousedown.stop="handleClick('3')">
        {{ $t(`button.saveToCloudTem`) }}
      </div>
    </div>
    <!-- <div @click="handlePrint">打印</div> -->
    <a-input-search
      class="share-input"
      v-model:value="querySearch.search"
      :placeholder="$t(`tips.tip5`)"
      @search="onSearch()"
    />
    <div class="content-nav" v-if="!showLabel">
      <div class="share-title" style="cursor: default">
        {{ $t(`label.label21`) }}
      </div>
      <div class="template-box">
        <div
          class="template-item"
          v-for="(item, index) in template.list"
          :key="index"
          @click="getLabel(index)"
        >
          <div class="template-icon">
            <div v-if="item.logo == null"></div>
            <div v-else class="iconfont" :class="item.logo"></div>
          </div>
          <div class="template-name">{{ item.name }}</div>
          <div class="template-remark">{{ item.remark }}</div>
        </div>
      </div>
      <div class="pagination" v-if="template.total > 0">
        <a-pagination
          v-model:current="queryTemplate.page"
          :pageSize="queryTemplate.count"
          :total="template.total"
          @change="getList()"
        />
      </div>
    </div>
    <div class="content-nav" v-else>
      <div class="share-title">
        <span @click="backTemplate" style="color: #7b89a1; cursor: pointer">{{
          $t(`label.label21`)
        }}</span>
        <RightOutlined />
        <span style="cursor: default">{{ listName }}</span>
      </div>
      <div class="share-order-nav" v-if="label.total > 0 && queryLabel.c_id">
        <a-select
          v-model:value="queryLabel.order"
          :bordered="false"
          @change="getLableList()"
        >
          <a-select-option value="">{{ $t(`label.label38`) }}</a-select-option>
          <a-select-option value="name asc">{{
            $t(`label.label39`)
          }}</a-select-option>
          <a-select-option value="name desc">{{
            $t(`label.label40`)
          }}</a-select-option>
          <a-select-option value="width asc,height asc">{{
            $t(`label.label43`)
          }}</a-select-option>
          <a-select-option value="width desc,height desc">{{
            $t(`label.label44`)
          }}</a-select-option>
        </a-select>
      </div>
      <div class="label-box">
        <div v-if="searchNull" class="index-none-content">
          <div class="none-img">
            <img src="../../assets/data.png" alt="" />
          </div>
          <p>{{ $t(`tips.tip23`) }}~</p>
        </div>
        <div
          v-else
          v-for="(item, index) in label.list"
          :key="index"
          @mousedown.stop=""
          style="margin-right: 24px; margin-bottom: 24px; position: relative"
        >
          <div @mousedown.stop="showPopover(index, $event)" class="label-item">
            <div class="label-image">
              <img class="image" :src="item.image_address" />
            </div>
            <div class="label-text">
              <div class="label-text-title">{{ item.name }}</div>
              <div class="label-text-size">
                {{ item.width }} X {{ item.height }}
              </div>
            </div>
          </div>
          <div
            @click="handleTempPrint(item)"
            style="
              position: absolute;
              opacity: 0.01;
              width: 30px;
              height: 30px;
              z-index: 888;
              background: #7b89a1;
              right: 0px;
              bottom: 0px;
            "
          ></div>
        </div>
      </div>
      <div class="pagination" v-if="label.total > 0 && !isSearch">
        <a-pagination
          v-model:current="queryLabel.page"
          :pageSize="queryLabel.count"
          :total="label.total"
          @change="getLableList()"
        />
      </div>
      <div class="pagination" v-if="label.total > 0 && isSearch">
        <a-pagination
          v-model:current="querySearch.page"
          :pageSize="querySearch.count"
          :total="label.total"
          @change="onSearch()"
        />
      </div>
    </div>
  </div>
  <PrintLabel
    v-if="printLabel"
    :labelData="labelData"
    @cancel="printLabel = false"
  />
  <MemberDia ref="MemberDiaRef" />
  <CopyLabel ref="copyRef" />
  <SizeOverTip ref="tipRef" />
  <CanvasTemplate ref="canvasTemplate" />
</template>
<script>
import MemberDia from "@/components/MemberDia.vue";
import CanvasTemplate from "@/components/CanvasTemplate.vue";
import SizeOverTip from "@/components/SizeOverTip.vue";
import { useRouter } from "vue-router";
import PrintLabel from "@/components/PrintLabel.vue";
import { message } from "ant-design-vue";
import CopyLabel from "@/components/CopyLabel.vue";
import { RightOutlined } from "@ant-design/icons-vue";
import { leftMenuPosition } from "@/utils/leftMenuPosition";
import {
  defineComponent,
  onMounted,
  nextTick,
  getCurrentInstance,
  watch,
  reactive,
  toRefs,
  onUnmounted,
} from "vue";
import ImagePrintDataSDK from "@/utils/ImagePrintDataSDK.js";
const imageLzo = new ImagePrintDataSDK();
imageLzo.setSkipAuth("110");
let bluetoothSDK = "";
export default defineComponent({
  components: {
    RightOutlined,
    CanvasTemplate,
    PrintLabel,
    CopyLabel,
    MemberDia,
    SizeOverTip,
  },
  setup() {
    const router = useRouter();
    const { proxy } = getCurrentInstance();
    let globalProperties =
      getCurrentInstance().appContext.config.globalProperties;
    const axios = globalProperties.$axioshanma;
    bluetoothSDK = globalProperties.$bluetoothSDK;
    console.log("bluetoothSDK", bluetoothSDK);

    const userInfo = JSON.parse(localStorage.getItem("userInfo"));
    const state = reactive({
      tipRef: null,
      MemberDiaRef: null,
      canvasTemplate: null,
      template: {
        list: "",
        total: 0,
      },
      queryTemplate: {
        count: 18,
        page: 1,
      },
      label: {
        list: "",
        total: 0,
      },
      queryLabel: {
        count: 12,
        page: 1,
        c_id: "",
        order: "",
      },
      querySearch: {
        count: 12,
        page: 1,
        search: "",
      },
      labelPopover: {
        labelVisible: false,
        showPopoverIndex: "",
      },
      showLabel: false,
      isSearch: false,
      printLabel: false,
      labelData: {},
      searchNull: false,
      listName: "",
      copyRef: null,
      popover: {
        left: 0,
        top: 0,
      },
    });
    onMounted(() => {
      getList();
      window.addEventListener("DOMMouseScroll", closePopover);
    });
    const closePopover = () => {
      state.labelPopover.labelVisible = false;
      state.labelPopover.showPopoverIndex = -1;
    };
    //监听language的变化
    watch(
      () => proxy.$i18n.locale,
      () => {
        getList();
        state.showLabel = false;
      }
    );
    onUnmounted(() => {
      window.removeEventListener("DOMMouseScroll", closePopover);
    });

    //获取模板列表
    const getList = () => {
      state.searchNull = false;
      axios("/api/tem.app_public/getSharedClass", state.queryTemplate).then(
        (res) => {
          state.template.list = res.list;
          state.template.total = res.count;
          nextTick(() => {
            let box = document.getElementsByClassName("template-box")[0];
            box.addEventListener("mouseover", () => {
              box.style.overflowY = "auto";
            });
            box.addEventListener("mouseout", () => {
              box.style.overflowY = "hidden";
            });
          });
        }
      );
    };
    //切换到标签列表页标签列表
    const getLabel = (index) => {
      state.searchNull = false;
      state.listName = state.template.list[index].name;
      state.queryLabel.c_id = state.template.list[index].id;
      getLableList();
    };
    //获取标签列表
    const getLableList = () => {
      axios("/api/tem.app_public/getSharedList", state.queryLabel).then(
        (res) => {
          state.isSearch = false;
          state.label.list = res.list;
          state.label.total = res.count;
          state.showLabel = true;
          nextTick(() => {
            let box = document.getElementsByClassName("label-box")[0];
            if (box) {
              box.addEventListener("mouseover", () => {
                box.style.overflowY = "auto";
              });
              box.addEventListener("mouseout", () => {
                box.style.overflowY = "hidden";
              });
            }
          });
        }
      );
    };

    //返回模板列表
    const backTemplate = () => {
      state.showLabel = false;
      state.queryLabel.page = 1;
      state.queryLabel.order = "";
      state.queryLabel.c_id = 1;
      state.searchNull = false;
      state.querySearch.page = 1;
      state.isSearch = false;
      nextTick(() => {
        let box = document.getElementsByClassName("template-box")[0];
        if (box) {
          box.addEventListener("mouseover", () => {
            box.style.overflowY = "auto";
          });
          box.addEventListener("mouseout", () => {
            box.style.overflowY = "hidden";
          });
        }
      });
    };
    //搜索
    const onSearch = (e) => {
      state.listName = "搜索内容";
      state.queryLabel.c_id = "";
      if (!state.querySearch.search) {
        state.isSearch = false;
        state.showLabel = false;
        getList();
        return;
      }
      axios("/api/tem.app_public/getSearchList", state.querySearch).then(
        (res) => {
          state.isSearch = true;
          state.label.list = res.list;
          state.label.total = res.count;
          state.showLabel = true;
          if (res.count == 0) {
            state.searchNull = true;
          } else {
            state.searchNull = false;
          }
        }
      );
    };
    //显示标签操作
    const showPopover = (index, event) => {
      if (state.labelPopover.showPopoverIndex == index) {
        state.labelPopover.labelVisible = false;
        state.labelPopover.showPopoverIndex = -1;
        return;
      }
      state.labelPopover.labelVisible = true;
      state.labelPopover.showPopoverIndex = index;
      nextTick(() => {
        state.popover = leftMenuPosition(event, "share-popover-box");
      });
    };
    //标签操作
    const handleClick = (e) => {
      let value = state.label.list[state.labelPopover.showPopoverIndex];
      if (e == 1) {
        //立即打印
        if (!value.file_pc) {
          message.error(proxy.$t(`tips.tip103`));
        } else {
          state.printLabel = true;
          state.labelData = value;
          state.labelData.shareTemp = true;
        }
      } else if (e == 2) {
        //编辑标签
        if (value.size / 1024 > globalProperties.$largerSize) {
          state["tipRef"].show();
        } else {
          if (!value.file_pc) {
            message.error(proxy.$t(`tips.tip103`));
          } else {
            localStorage.setItem("list", JSON.stringify(value));
            localStorage.setItem("listType", 3);
            axios("/api/tem.app_public/addDowTem", {
              id: value.id,
            }).then((res) => {
              console.log("模板下载记录添加成功");
            });
            axios("/api/tem.app_public/userUseTem", {
              id: value.id,
              user_id: userInfo.userid,
            }).then((res) => {
              console.log("模板使用记录添加成功");
            });
            router.push({ path: "/editLabel" });
          }
        }
      } else if (e == 3) {
        //保存到云端模板
        state.copyRef.show("templateSaveTo", value, state.MemberDiaRef);
      }
      nextTick(() => {
        state.labelPopover.labelVisible = false;
        state.labelPopover.showPopoverIndex = "";
      });
    };

    const handlePrint = () => {
      let txt =
        "1b 1c 26 20 56 31 20 67 65 74 76 61 6c 20 22 70 72 69 6e 74 65 72 5f 6e 61 6d 65 22 0d 0a";
      bluetoothSDK.conveyingInstruct(txt);
    };
    const handleTempPrint = (item) => {
      state.canvasTemplate.init(item).then(async (res) => {
        let parameter = {
          x: 0,
          y: 0,
          width: item.width,
          height: item.height,
          slice: 1, //切图，esc指令
          dpi: 203,
          share: 1, //分数
          instruct: "TSPL", //指令集
          imageData: res,
          paper: 0, //纸张类型
          align: 1,
          depth: 3, //浓度
          printerHeadWidth: 80,
        };

        let printData = imageLzo.printLzoData(parameter);
        for (let i = 0; i < printData.length; i++) {
          await bluetoothSDK.conveyingInstruct(printData[i]);
        }
      });
    };

    return {
      ...toRefs(state),
      onSearch,
      getLabel,
      backTemplate,
      getList,
      showPopover,
      handleClick,
      handlePrint,
      handleTempPrint,
      getLableList,
    };
  },
});
</script>
<style scoped>
.share-nav {
  margin: 28px 0px 0px 16px;
}
.share-input {
  margin-left: 24px;
}

.content-nav {
  font-size: 20px;
  margin-top: 20px;
}
.share-title {
  display: inline-block;
  height: 26px;
  font-size: 18px;
  font-weight: 500;
  color: #535d6c;
  line-height: 26px;
  margin-top: 24px;
  margin-left: 24px;
}
.template-box {
  width: 100%;
  height: calc(100vh - 200px);
  padding-top: 24px;
  padding-left: 24px;
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  align-content: flex-start;
  justify-content: flex-start;
  overflow: hidden;
  overflow-y: hidden;
}
.template-item {
  width: 240px;
  height: 224px;
  box-sizing: border-box;
  background: #ffffff;
  border-radius: 4px;
  border: 1px solid #d6dce6;
  margin-right: 24px;
  margin-bottom: 24px;
  padding: 16px;
  cursor: pointer;
}
.template-item:hover {
  box-shadow: 0px 4px 8px 0px rgba(145, 152, 165, 0.24);
  z-index: 99;
}
.template-icon {
  width: 64px;
  height: 64px;
  background-color: rgba(0, 53, 145, 0.1);
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
}
/* .template-icon .anticon {
  padding: 24px;
} */
.template-name {
  width: 100%;
  height: 32px;
  font-size: 20px;
  font-weight: 500;
  color: #1a1d21;
  line-height: 32px;
  margin-top: 24px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.template-remark {
  margin-top: 8px;
  width: 100%;
  height: 48px;
  font-size: 14px;
  color: #535d6c;
  line-height: 24px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  word-wrap: break-word;
  word-break: normal;
  font-weight: 400;
}
.share-order-nav {
  float: right;
  margin-top: 24px;
  margin-right: 40px;
}
.index-none-content {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
}
.none-img {
  width: 276px;
  height: 160px;
}
.none-img > img {
  width: 100%;
  height: 100%;
}
.index-none-content > p {
  margin-top: 11px;
  height: 22px;
  font-size: 16px;
  color: #535d6c;
  line-height: 22px;
}
.label-box {
  width: 100%;
  height: calc(100vh - 205px);
  padding-top: 24px;
  padding-left: 24px;
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  align-content: flex-start;
  justify-content: flex-start;
  overflow: hidden;
  overflow-y: hidden;
}
.label-item {
  width: 240px;
  height: 296px;
  background: #ffffff;
  border-radius: 4px;
  border: 1px solid #d6dce6;
  cursor: pointer;
  position: relative;
}
.label-item:hover {
  box-shadow: 0px 4px 8px 0px rgba(145, 152, 165, 0.24);
  transform: scale(1.08);
  z-index: 999;
}
.label-image {
  width: 208px;
  height: 204px;
  background: #f5f8fc;
  margin-top: 16px;
  margin-left: 16px;
  box-sizing: border-box;
  display: flex;
  align-content: center;
  justify-content: center;
}
.label-image > img {
  max-width: 176px;
  max-height: 172px;
}
.image {
  max-width: 176px;
  max-height: 172px;
  margin: 16px auto;
  object-fit: contain;
}
.label-text {
  margin-left: 16px;
  margin-top: 10px;
  margin-right: 16px;
}
.label-text-title {
  width: 100%;
  height: 24px;
  font-size: 16px;
  color: #1a1d21;
  line-height: 24px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.label-text-size {
  display: block;
  height: 20px;
  font-size: 14px;
  color: #7b89a1;
  line-height: 20px;
  margin-top: 4px;
}
.share-popover-box {
  min-width: 180px;
  width: fit-content;
  height: 158px;
  border-radius: 4px;
  background-color: #fff;
  box-sizing: border-box;
  top: 120px;
  left: 80px;
  padding-top: 8px;
  padding-bottom: 8px;
  position: absolute;
  z-index: 1030;
  cursor: auto;
  -webkit-user-select: text;
  -moz-user-select: text;
  -ms-user-select: text;
  user-select: text;
  box-shadow: 0px 4px 8px 0px rgba(145, 152, 165, 0.24);
}

.share-popover-box .item-popover {
  cursor: pointer;
  width: 100%;
  text-align: center;
  font-size: 14px;
  height: 48px;
  font-size: 16px;
  color: #535d6c;
  line-height: 48px;
  padding-left: 8px;
  padding-right: 8px;
  white-space: nowrap;
}

.share-popover-box .item-popover:hover {
  background-color: rgba(0, 53, 145, 0.1);
  color: #003591;
  margin-bottom: 0;
  margin-top: 0;
  border-radius: 0;
}
@media only screen and (max-width: 1300px) {
  .share-nav {
    margin: 20px 0px 0px 10px;
  }
  .share-input {
    margin-left: 16px;
  }
  .content-nav {
    font-size: 14px;
    margin-top: 14px;
  }
  .share-title {
    height: 17px;
    font-size: 12px;
    line-height: 17px;
    margin-top: 16px;
    margin-left: 16px;
  }
  .template-box {
    padding-top: 16px;
    padding-left: 16px;
    height: calc(100vh - 165px);
  }
  .template-item {
    width: 160px;
    height: 149px;
    margin-right: 16px;
    margin-bottom: 16px;
    padding: 10px;
  }
  .template-icon {
    width: 42px;
    height: 42px;
  }
  .template-name {
    width: 100%;
    height: 21px;
    font-size: 14px;
    line-height: 21px;
    margin-top: 16px;
  }
  .template-remark {
    margin-top: 5px;
    width: 100%;
    height: 32px;
    font-size: 8px;
    line-height: 14px;
  }
  .share-order-nav {
    margin-top: 16px;
  }

  .none-img {
    width: 184px;
    height: 106px;
  }
  .index-none-content > p {
    margin-top: 5px;
    height: 15px;
    font-size: 10px;
    line-height: 15px;
  }
  .label-box {
    padding-top: 16px;
    padding-left: 16px;
    height: calc(100vh - 180px);
  }
  .label-item {
    width: 160px;
    height: 197px;
  }
  .label-image {
    width: 138px;
    height: 136px;
    margin-top: 10px;
    margin-left: 10px;
  }
  .label-image > img {
    max-width: 117px;
    max-height: 115px;
  }
  .image {
    max-width: 117px;
    max-height: 115px;
    margin: 10px auto;
  }
  .label-text {
    margin-left: 16px;
    margin-top: 10px;
    margin-right: 16px;
  }
  .label-text-title {
    height: 16px;
    font-size: 10px;
    line-height: 16px;
  }
  .label-text-size {
    height: 14px;
    font-size: 8px;
    line-height: 14px;
  }
  .share-popover-box {
    min-width: 120px;
    height: 105px;
    top: 80px;
    left: 60px;
    padding-top: 6px;
    padding-bottom: 6px;
  }

  .share-popover-box .item-popover {
    height: 32px;
    font-size: 10px;
    line-height: 32px;
    padding-left: 8px;
    padding-right: 8px;
  }
}
</style>
